/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { ModalProps } from "./interface";
import { modalStyles } from "./styles";
import closeLogo from "../../assets/close.svg";
import { useIsMobile } from "../../hooks/useIsMobile";

export const Modal: React.FunctionComponent<ModalProps> = (props) => {
  const { showCloseIcon } = props;
  const isMobileView = useIsMobile();
  // To close the modal on ESC key
  React.useEffect(() => {
    window.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        props.closeModal();
      }
    });
    return () => window.removeEventListener("keydown", (e) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // To close the modal on outside click
  const modalClicked = (e: any) => {
    if (!e.target.closest(".custom-modal")) {
      props.closeModal();
    }
  };

  return (
    <div
      className={`custom-modal-container
        ${props.className ? props.className : ""}
      `}
      css={modalStyles(props.modalSize, isMobileView ? true : false)}
      onClick={(e) => {
        modalClicked(e);
      }}
    >
      <div className="custom-modal">
        <div className="custom-modal-content">
          <div className="custom-modal-data">{props.children}</div>
          {showCloseIcon && showCloseIcon ? (
            <div>
              <img
                src={closeLogo}
                alt=""
                onClick={props.closeModal}
                className="close"
              />
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </div>
        {!!props.renderOutsideModalCard && (
          <div className="custom-modal-extra-content">
            {props.renderOutsideModalCard}
          </div>
        )}
      </div>
    </div>
  );
};
